import { useEffect, useRef, useState } from 'react';
import { useTable, usePagination } from 'react-table';

// Серверная таблица со страницами и быстрым поиском: общая обвязка вкладок чёрного списка.
// fetcher({ page, pageSize, all }) → axios-ответ с { [key]: [], pagination }; onData видит весь ответ (sync и т.п.).
// reload — любое меняющееся значение, при смене которого список перечитывается.
const useServerTable = ({ fetcher, key, columns, reload = 0, onData }) => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  // Первая загрузка: до неё таблица со своей пагинацией («1 из 1») над спиннером выглядит как сбой
  const [loaded, setLoaded] = useState(false);
  const [pagination, setPagination] = useState({
    page: 1,
    totalPages: 1,
    hasPreviousPage: false,
    hasNextPage: false,
    pageSize: 10,
  });
  const [isFetchAll, setFetchAll] = useState(false);
  const [value, setValue] = useState('');
  const [queryParams, setQueryParams] = useState({});
  const onDataRef = useRef(onData);
  onDataRef.current = onData;

  const table = useTable(
    {
      columns,
      data: items,
      initialState: { pageSize: 10 },
      manualPagination: true,
      pageCount: pagination.totalPages,
      page: pagination.page - 1,
      disableSortRemove: true,
    },
    usePagination
  );

  useEffect(() => {
    if (isFetchAll) return;
    setLoading(true);
    fetcher({ page: pagination.page, pageSize: pagination.pageSize, ...queryParams })
      .then((res) => {
        setItems(res?.data?.[key] || []);
        onDataRef.current?.(res?.data);
        // Читаем до setPagination: исключение внутри обновителя случается при рендере и роняет страницу
        const next = res?.data?.pagination;
        if (next) {
          setPagination((prev) => ({ ...next, page: next.pageNumber, pageSize: prev.pageSize }));
        }
      })
      .catch(() => {})
      .finally(() => {
        setLoading(false);
        setLoaded(true);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.page, pagination.pageSize, queryParams, isFetchAll, reload]);

  const search = (text) => {
    setQueryParams({ all: (text || '').trim() });
    setPagination((prev) => ({ ...prev, page: 1 }));
  };

  // Для <Table>: общие пропсы серверной таблицы
  const tableProps = {
    table,
    pagination: true,
    setPagination,
    setFetchAll,
    isFetchAll,
    setData: setItems,
    p: pagination,
    loading,
    setLoading,
    queryParams,
  };

  return {
    table,
    tableProps,
    loaded,
    loading,
    searching: !!queryParams.all,
    value,
    setValue,
    search,
    setPagination,
  };
};

export default useServerTable;
